import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import {FormGroup, Input, Label, Container, Row, Col} from "reactstrap"

class StandardAddress extends Component {
    state = {
        isShipVP: false,    
    }
    _handleChangeInput = (e) => {
        const {type, checked, name} = e.target
        const value = type === 'checkbox' ? checked : e.target.value
        const {onChangeInput} = this.props

        if (typeof onChangeInput === 'function') {
            onChangeInput(name, value)
        }
    }

    _handleChangeInputRA = (e) => {
        const {value, name} = e.target
        const {onChangeInputRA} = this.props

        if (typeof onChangeInputRA === 'function') {
            onChangeInputRA(name, value)
        }
    }

    render() {
        const {item, itemRA, onChangeShipOffice, isShipVP} = this.props
        const {orderNumber = '', name = '', address1 = '', address2 = '', city = '', state = '', country = '', phone = '', postalCode = '', qship = '', ioss = '', tags = []} = item
        const {name: return_name = '', address1: return_address1 = '', address2: return_address2 = '', country: return_country = '', state: return_state = '', city: return_city = '', postalCode: return_postalCode = '', email: return_email = '', phone: return_phone = ''} = itemRA
        const hasShipVP = tags.includes('ship_VP')
        const hasShippedVhmc = tags.includes('shipped_vhmc')
        const hasReturned = tags.includes('returned')
        const isDisabled = hasShipVP && hasShippedVhmc && !hasReturned
        return (
            <Fragment>
                <Container>
                    <Row xs="2">
                        <Col>
                            <h3>Return Address</h3>
                            <FormGroup>
                                <Label>Name</Label>
                                <Input name='name' value={return_name} onChange={this._handleChangeInputRA}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>Address1</Label>
                                <Input name='address1' value={return_address1} onChange={this._handleChangeInputRA}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>Address2</Label>
                                <Input name='address2' value={return_address2} onChange={this._handleChangeInputRA}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>City</Label>
                                <Input name='city' value={return_city} onChange={this._handleChangeInputRA}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>State</Label>
                                <Input name='state' value={return_state} onChange={this._handleChangeInputRA}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>Country</Label>
                                <Input name='country' value={return_country} onChange={this._handleChangeInputRA}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>Postal Code</Label>
                                <Input name='postalCode' value={return_postalCode} onChange={this._handleChangeInputRA}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>Email</Label>
                                <Input name='email' value={return_email} onChange={this._handleChangeInputRA}/>
                            </FormGroup>
                            <FormGroup>
                                <Label check>Phone</Label>
                                <Input name='phone' value={return_phone} onChange={this._handleChangeInputRA}/>
                            </FormGroup>
                            <div className="mb-3">
                                <FormGroup check>
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            checked={isShipVP}
                                            onChange={(e) => {
                                                if (typeof onChangeShipOffice === 'function') {
                                                    onChangeShipOffice(e.target.checked)
                                                }
                                            }}
                                            disabled={isDisabled}
                                        />
                                        Ship văn phòng
                                    </Label>
                                    {isDisabled && (
                                        <small className="text-warning d-block">
                                            Không thể thay đổi khi đã shipped vhmc
                                        </small>
                                    )}
                                </FormGroup>
                            </div>
                        </Col>

                        <Col>
                            <h3>Shipping address</h3>
                            <FormGroup>
                                <Label>Order Number</Label>
                                <Input name='orderNumber' value={orderNumber} onChange={this._handleChangeInput}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>Name</Label>
                                <Input name='name' value={name} onChange={this._handleChangeInput}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>Address1</Label>
                                <Input name='address1' value={address1} onChange={this._handleChangeInput}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>Address2</Label>
                                <Input name='address2' value={address2} onChange={this._handleChangeInput}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>City</Label>
                                <Input name='city' value={city} onChange={this._handleChangeInput}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>State</Label>
                                <Input name='state' value={state} onChange={this._handleChangeInput}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>Country</Label>
                                <Input name='country' value={country} onChange={this._handleChangeInput}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>Phone</Label>
                                <Input name='phone' value={phone} onChange={this._handleChangeInput}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>Postal Code</Label>
                                <Input name='postalCode' value={postalCode} onChange={this._handleChangeInput}/>
                            </FormGroup>
                            <FormGroup>
                                <Label check>FastShip</Label>
                                <Input name='qship' value={qship} onChange={this._handleChangeInput}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>IOSS number</Label>
                                <Input name='ioss' value={ioss} onChange={this._handleChangeInput}/>
                            </FormGroup>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

StandardAddress.propTypes = {
    item: PropTypes.object.isRequired,
    itemRA: PropTypes.object.isRequired,
    onChangeInput: PropTypes.func.isRequired,
    onChangeInputRA: PropTypes.func.isRequired,
    onChangeShipOffice: PropTypes.func
}

export default StandardAddress
